import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=b3397c3a&scoped=true&"
import script from "./spinner.vue?vue&type=script&lang=js&"
export * from "./spinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3397c3a",
  null
  
)

export default component.exports